<ion-list (click)="close()" lines="none" class="ion-align-items-start">
  <ion-item routerLink="/account">
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 154 139"
      style="enable-background: new 0 0 154 139"
      xml:space="preserve"
    >
      <style type="text/css">
        .st0 {
          clip-path: url(#SVGID_2_);
        }
      </style>
      <g>
        <defs>
          <rect id="SVGID_1_" x="0.8" width="153" height="139" />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow: visible" />
        </clipPath>
        <g>
          <path
            d="M95.5,138.2c-14.2,0-28.4-0.1-42.6,0c-11.4,0.1-22.8,0.4-34.2,0.5c-3.2,0-6.4-0.2-9.6-0.7c-6.8-1-9.6-5-7.3-11.5
			c1.6-4.4,3.6-8.5,6.1-12.5c10.5-16.8,25.7-27.7,44-34.7c9.9-3.9,20.5-6,31.1-6.1c15.9-0.1,30.6,3.9,43.2,14.4
			c8.6,7.1,15.6,15.8,20.5,25.7c1.4,2.8,3,5.5,4.1,8.3c1.1,2.7,1.8,5.4,2.2,8.3c0.5,4.2-1.8,7.1-6.1,7.6c-3,0.4-5.9,0.6-8.9,0.7
			C123.9,138.1,109.7,138.1,95.5,138.2L95.5,138.2z M142.2,127.8c0.1-0.5,0.1-0.9,0-1.4c-4.5-11.7-10.8-22.3-20.4-30.6
			c-7.4-6.4-15.8-11-25.7-12.2c-11.4-1.4-22.8-1.1-33.9,2c-21.1,5.9-38,17.6-49.6,36.5c-1.3,2.1-2.4,4.5-3.6,6.8
			c0.4,0.2,0.8,0.4,1.1,0.5c4,0.9,7.9,0.4,11.9,0.1c8.3-0.5,16.6-0.7,24.9-0.7c27.2-0.1,54.3-0.1,81.5-0.3
			C132.9,128.5,137.4,128.1,142.2,127.8L142.2,127.8z"
          />
          <path
            d="M80.1,0.5c10.9-0.3,20.1,4.9,27,14.4c1.6,2.2,3.6,4.3,4.8,6.7c2.7,5.5,4.9,11.1,3.5,17.5c-1.3,6-3.1,11.8-6.9,16.7
			c-6.9,8.7-15.7,14.1-26.9,15.5c-10.1,1.2-19.7-0.3-28.6-5c-9.2-4.9-14.5-12.8-16.4-22.9C33.6,28,41.6,14.3,54.3,7
			C61.9,2.6,70.2,0.4,80.1,0.5z M104,31.5c0.5-3.8-1-6.9-3.4-9.7c-0.9-1.1-1.8-2.3-2.7-3.3c-3.5-3.8-7.5-6.9-12.9-7.7
			c-7.5-1.2-15.2-0.2-22.1,2.9c-8.6,4-15.1,10-16.6,20c-1.7,11.7,4.3,22.2,15.1,25.7c6.5,2,13.3,2.6,20,1.7c9.2-1,20-10.5,21.4-20.1
			C103.3,37.8,103.6,34.6,104,31.5L104,31.5z"
          />
        </g>
      </g>
    </svg>
    <ion-label> Mi perfil</ion-label>
  </ion-item>
  <ion-item routerLink="/pedidos">
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 143 107"
      style="enable-background: new 0 0 143 107"
      xml:space="preserve"
    >
      <style type="text/css">
        .st0 {
          clip-path: url(#SVGID_2_);
        }
      </style>
      <g>
        <defs>
          <rect id="SVGID_1_" x="0.8" width="142" height="107" />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow: visible" />
        </clipPath>
        <g>
          <path
            d="M46.3,14.6c1.2,0.8,2.5,1.3,3.9,1.6c2.5,0.3,4.9,0.5,7.4,0.5c4,0.1,8,0.2,12,0.3c10.2,0.2,20.7,0.5,31.1,0.5
			c0.8,0,1.5,0,2.3,0c8.2,0,16.5-0.5,24.5-0.9c2.5-0.1,5-0.3,7.5-0.4c1.1-0.1,2.2-0.4,3.2-0.8c0.6-0.2,1.2-0.4,1.8-0.6
			c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.2-0.2c0-0.1,0.1-0.2,0-0.3c0-0.1,0-0.2-0.1-0.3c-1.7-2.9-3.9-3.1-5.6-3.4
			c-0.2,0-0.5-0.1-0.7-0.1c-10.3-1.7-19.6-3.2-29.2-3.2c-3.2,0-6.4,0-9.7-0.1c-4.9,0-10-0.1-15-0.1C71,7,61.8,7.1,52.8,7.3
			c-2.1,0-4.1,0.4-6,1.2c-0.6,0.2-1,0.6-1.4,1.1c-0.3,0.5-0.5,1.1-0.6,1.7c-0.1,0.6,0,1.3,0.3,1.9C45.4,13.8,45.8,14.3,46.3,14.6z"
          />
          <path
            d="M142.3,57.8c-0.2-0.6-0.4-1.2-1-1.4c-1.3-0.5-2.6-0.9-4-1.1c-2.8-0.3-5.6-0.6-8.5-0.9c-7.2-0.8-14.7-1.6-22.1-1.9
			c-13.8-0.6-27.8-0.8-41.4-1.1c-4.4-0.1-8.9-0.2-13.3-0.3c-1.6-0.1-3.3,0.2-4.8,0.7c-0.6,0.3-1.1,0.7-1.5,1.2
			c-0.4,0.5-0.7,1-0.9,1.6c-0.2,0.8-0.2,1.7,0.2,2.4c0.4,0.7,1,1.3,1.8,1.6c1.9,0.8,3.9,1.3,5.9,1.5c7.6,0.6,15.3,1.1,22.8,1.5
			l2.5,0.2c8.2,0.5,16.2,0.8,24,0.8c10.3,0,20.2-0.4,30-1.3c0.5,0,1-0.1,1.5-0.1c2.8-0.2,5.7-0.4,8.5-1.8c0.2-0.1,0.3-0.2,0.3-0.4
			c0.1-0.2,0-0.3,0-0.5C142.4,58.3,142.3,58,142.3,57.8z"
          />
          <path
            d="M139.1,94c-0.2-0.1-0.5-0.2-0.7-0.2c-0.5-0.2-1-0.3-1.5-0.4c-2.4-0.2-4.9-0.3-7.3-0.5c-6.1-0.4-12.4-0.9-18.6-1.1
			c-18-0.5-36.4-0.7-54.2-0.9l-2.5,0c-1.9,0-3.7,0.4-5.4,1.1c-0.6,0.3-1.1,0.7-1.5,1.2c-0.4,0.5-0.6,1.2-0.6,1.8
			c-0.1,0.7,0.1,1.4,0.4,2c0.3,0.6,0.8,1.2,1.4,1.5c1,0.6,2.1,1.1,3.3,1.2l1.4,0.2c3.1,0.5,6.2,0.8,9.3,0.9
			c5.5,0.1,11.1,0.2,16.6,0.3c3.8,0,7.6,0.1,11.5,0.1c1.2,0,2.3,0,3.5,0c12.8,0,25.6-1.2,36.5-2.4l1.2-0.1c1.8-0.2,3.6-0.4,5.4-0.7
			c1.8-0.3,2.6-1.5,2.4-3.5c0-0.1-0.1-0.2-0.2-0.3C139.3,94.1,139.2,94.1,139.1,94z"
          />
          <path
            d="M12,85.5C6.7,85,3.6,88.3,1.3,91.6c-0.1,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2,0,0.3c0.1,0.5,0.2,1.1,0.3,1.5
			c0.2,1,0.4,1.8,0.5,2.6c0.2,1.9,0.9,3.8,2,5.4c1.1,1.6,2.6,2.9,4.3,3.9c1.6,0.9,3.5,1.3,5.4,1.3c1.9,0,3.8-0.5,5.6-1.3
			c1.3-0.6,2.4-1.4,3.4-2.4c0.9-1,1.6-2.3,2-3.6c0.3-1.3,0.3-2.7,0.1-4c-0.3-1.3-0.8-2.6-1.6-3.6c-1.2-1.8-2.8-3.4-4.7-4.5
			C16.3,86.3,14.2,85.6,12,85.5z"
          />
          <path
            d="M13,25.2c0.3,0,0.6,0,0.9,0c2.5,0.1,4.9-0.7,6.9-2.2c2-1.5,3.3-3.6,3.9-6c1.2-5.1-0.3-9.6-4.3-13.2
			c-3.8-3.4-8.3-4-13.1-1.9c-1,0.5-1.9,1-2.9,1.6c-0.5,0.3-1,0.6-1.6,0.9C2.7,4.4,2.6,4.5,2.5,4.6C2.5,4.7,2.4,4.8,2.4,4.9
			C2.3,6,2.2,7.1,2.1,8.1c-0.3,2.1-0.4,4.3-0.4,6.5C2,20.3,6.7,24.7,13,25.2z M11.2,7.6c1,0.3,1.9,0.8,2.7,1.5
			c0.8,0.7,1.4,1.5,1.8,2.4c0.8,1.7,0.7,3.1-0.3,4.2c-0.8,0.9-1.9,1.2-3.6,0.7c-0.8-0.2-1.4-0.5-2-1.1c-0.5-0.6-0.8-1.3-0.9-2
			C8.4,11.1,9.2,9.2,11.2,7.6z"
          />
          <path
            d="M16,45.5L16,45.5c-8,0.1-12.7,4.3-13,11.6c-0.1,1.3,0.2,2.5,0.6,3.7c0.5,1.2,1.2,2.3,2,3.2C6.7,65.2,8,66,9.5,66.6
			c1.4,0.6,3,0.9,4.5,0.8h0.1c1.6,0,3.1-0.3,4.5-0.8c1.4-0.6,2.8-1.4,3.9-2.5c1-1,1.7-2.1,2.3-3.4c0.5-1.3,0.8-2.6,0.7-4
			C25.4,50.5,21.1,45.5,16,45.5z M14.9,57.2h-3.1c-0.8-1.9-0.4-3.2,1.3-4.4C14.6,53.6,15.5,54.7,14.9,57.2z"
          />
        </g>
      </g>
    </svg>
    <ion-label> Mis Pedidos</ion-label>
  </ion-item>
  <ion-item routerLink="/embajadores">
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 159 157"
      style="enable-background: new 0 0 159 157"
      xml:space="preserve"
    >
      <style type="text/css">
        .st0 {
          clip-path: url(#SVGID_2_);
        }
      </style>
      <g>
        <defs>
          <rect id="SVGID_1_" x="0.8" width="158" height="157" />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow: visible" />
        </clipPath>
        <g>
          <path
            d="M35,132.6c0.9-0.1,1.7-0.1,2.6-0.2c1.8-0.1,3.6-0.3,5.4-0.3c4.1,0,8.2,0,12.2,0.1l3.1,0c0.3,0,0.5,0.1,0.8,0.1
			c-1.3,4.6-3.5,8.8-6.3,12.7c-1.4,1.9-2.8,2.6-4.7,2.3c-1.3-0.1-2.6-0.1-3.9,0.2c-0.7,0.1-1.4,0.5-1.9,1.1c-0.5,0.6-0.8,1.3-0.9,2
			c-0.1,1,0.2,2.3,2.1,3.3c0.9,0.4,1.8,0.7,2.7,0.9c0.7,0.1,1.5,0.2,2.2,0.3c2.8,0.4,5.6,0.7,8.4,0.8c4.1,0.2,8.3,0.2,12.4,0.2
			c2.4,0,4.9,0,7.3,0.1c0.6,0,1.2,0.1,1.8,0.3c0.3,0.1,0.6,0.1,0.9,0.2c0,0,0.1,0,0.1,0h16c0.1,0,0.1,0,0.2,0
			c0.2-0.1,0.4-0.1,0.6-0.2c0.3-0.1,0.7-0.2,1.1-0.3c0.9,0,1.9,0,2.8,0c1.6,0,3.3,0,4.9-0.2c2.1-0.2,4.1-0.7,5.9-1.6
			c0.6-0.2,1.1-0.6,1.4-1.1c0.4-0.5,0.6-1.1,0.6-1.7c0-0.6-0.2-1.2-0.6-1.8c-0.3-0.5-0.8-1-1.4-1.2c-1.1-0.6-2.4-1-3.7-1.2
			c-0.9-0.1-1.7-0.1-2.6-0.1c-0.2,0-0.4,0-0.7,0c-0.6-1.6-1.3-3.2-2-4.8c-1.4-3.1-2.6-6-3.3-9.3h2.8c3,0,5.8,0,8.7,0
			c0.7,0,1.5,0.1,2.2,0.1c0.5,0,0.9,0.1,1.4,0.1c0.6,0,1.3,0.1,1.9,0.1c1.6,0.2,3.2,0.2,4.8,0.2c3.5-0.2,7-0.6,10.3-1
			c3.4-0.4,7.2-1.1,10.4-3c11.6-7,17.3-16.9,17-29.6c-0.2-7.7-0.2-15.6-0.2-23.2l0-3.7c0-3.1,0-6.3,0.1-9.3c0.1-6,0.1-12.2-0.1-18.3
			c-0.4-7.1-1.2-14.2-2.5-21.2c-1.4-7.8-4.6-13.5-9.8-17.5c-6.5-5-14.7-7.5-22.9-6.8c-7.4,0.5-14.1,0.8-20.6,1
			c-6.7,0.2-13.5,0.2-20,0.1c-9.6,0-19.6-0.1-29.3,0.6c-4.1,0.3-8.2,0.4-12.2,0.4c-3.6,0.1-7.4,0.2-11.1,0.4
			c-7.1,0.4-13.2,2.7-18.2,6.8c-2.6,2-4.7,4.5-6.3,7.4c-1.6,2.8-2.6,6-3,9.2c-0.5,4.5-0.7,9.1-0.6,13.6l0,0.4c0,1.9,0.1,3.7,0.2,5.6
			c0.1,1.4,0.2,2.9,0.2,4.4c0.2,13,0.4,26.7,0.6,43.3c0,0.8-0.1,1.5-0.2,2.2c-0.1,0.8-0.2,1.6-0.2,2.4c0,1.2,0.1,2.5,0.1,3.7
			c0.1,1.4,0.2,2.9,0.1,4.3c-0.1,5.2,1.7,10.2,5.1,14.9C13.9,129.5,23.1,133.4,35,132.6z M149.5,75l0,6.8c0,6.8,0,13.8,0,20.7
			c0,1.5-0.3,3-0.7,4.4c-1,3.5-2.8,6.8-5.1,9.7c-3.5,4.4-8.3,7-14.8,8c-3.6,0.6-7.3,1-11.5,1.3c-1.1,0-2.2,0-3.3-0.2
			c-0.7-0.1-1.5-0.2-2.2-0.2c-2.8-0.1-5.7-0.2-8.5-0.3c-5.4-0.2-11-0.3-16.5-0.7c-8-0.5-16-0.7-24-0.7c-4,0-7.9,0-11.9,0.1
			c-5.9,0-12,0.1-17.9,0c-4.4,0-7.9-0.7-11-2.2c-2.3-1-4.4-2.5-6.1-4.4c-1.7-1.9-3-4.1-3.9-6.4c-1.7-4.7-2.3-8.9-1.8-13
			c0.1-1.2,0.2-2.4,0.1-3.6c0-0.4,0-0.7,0-1.1c0-3,0-6,0-9.1c0-8.1,0.1-16.4,0-24.6c0-3.2-0.1-6.5-0.2-9.6
			c-0.1-3.7-0.3-7.6-0.2-11.3c0-5.6,1.2-11,3.6-16.1c2.5-5.2,7.1-8.5,13.6-9.7c3.8-0.7,7.6-1.1,10.8-1.4c14-1.2,28.2-1.4,42-1.5
			c3.1,0,6.2-0.1,9.3-0.1c4.4-0.1,8.8-0.1,13.1-0.1c7-0.1,14.1-0.1,21.2-0.3c4.9-0.1,9.8,1.5,15.2,4.9c3.1,1.9,5.3,5.2,6.5,9.6
			c1,3.5,1.6,7.2,2.3,10.7l0.4,1.9c0.4,2.3,0.8,4.9,1.2,7.8c0.2,1.8,0.3,3.7,0.3,5.6c0,6.1,0,12.2,0,18.3v6.6
			C149.5,75,149.5,75,149.5,75L149.5,75z M63.4,145.8c0.9-1.8,1.7-3.6,2.3-5.5c0.6-1.9,1-3.8,1.3-5.7c0.1-0.7,0.3-1.4,0.4-2.1
			l22.5,0.4c0.4,5.3,2,10,3.8,14.2h-31C63,146.7,63.2,146.3,63.4,145.8z"
          />
          <g>
            <g>
              <path
                d="M115.8,51.2c-1.6,0-2.6-0.4-3.2-1.6c-0.5-1.1-0.2-2,0.4-2.9c0.3-0.5,0.7-0.9,1.2-1.2c2.5-1.6,5-3.2,7.5-4.6
					c0.9-0.4,1.8-0.5,2.7-0.5c0.5,0.1,0.9,0.2,1.2,0.5c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.8,0.4,1.2c0,0.5-0.1,0.9-0.2,1.2
					c-0.5,1-1.2,1.9-2.1,2.5c-2.3,1.4-4.7,2.6-7.2,3.8C116.9,51,116.4,51.1,115.8,51.2z"
              />
              <path
                d="M40.2,54.5c-0.5-0.3-1.7-0.7-2.5-1.5c-1.3-1.2-2.5-2.6-3.6-4.2c-0.5-0.8-0.9-1.7-0.9-2.6c0-1.7,1.9-3,3.7-2.3
					c1.6,0.5,3,1.2,4.2,2.3c1.2,1,2.3,2.3,3,3.7C45.3,52.4,43.6,54.6,40.2,54.5z"
              />
              <path
                d="M106.2,19.9c2.5,0,3.9,1.8,3.4,3.7c-0.2,0.6-0.4,1.2-0.9,1.7c-1.6,1.7-3.3,3.4-5.1,5c-0.9,0.8-2,1.3-3.3,0.9
					c-1.6-0.5-2.3-1.8-1.8-3.3c0.2-0.5,0.3-0.9,0.6-1.2c1.6-1.8,3.1-3.7,4.7-5.4C104.7,20.6,105.7,20.2,106.2,19.9z"
              />
              <path
                d="M62.7,29c-0.2,1.4-0.7,2.5-2,3.1c-1.2,0.5-2.3,0.2-3-0.6c-1.8-1.7-3.2-3.8-4-6.2c-0.5-1.6,0-3,1.2-3.8
					c1.2-0.8,2.6-0.7,3.9,0.6C60.6,24,62.2,26.2,62.7,29z"
              />
              <path
                d="M133.5,65.8c0-1.2-0.2-2.4-0.6-3.5c-0.5-1.5-1.6-2.6-2.8-2.9c-1.2-0.4-2.6,0-4,1.1c-0.9,0.8-1.9,1.6-2.8,2.4
					c-0.4,0.3-0.8,0.7-1.1,1l-5,4.4c-4,3.6-8.2,7.2-12.2,10.8c-0.3,0.2-0.6,0.5-0.9,0.7c-0.2,0.1-0.2,0.2-0.4,0.2
					c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.9-2.5-1.8-5-2.6-7.4
					c-1.9-5.4-4-11.1-6.1-16.6c-3-7.6-6.1-15-9.1-21.8c-0.8-1.6-1.9-3.2-3.1-4.4c-1.2-1.2-2.4-1.3-4.1-0.3c-1.4,0.9-1.9,2.3-2.6,3.7
					l-0.1,0.2c-0.6,1.5-1.2,3-1.9,4.5c-1.9,4.4-3.8,9.2-5.9,13.8c-3.1,6.9-6.5,13.9-9.6,20.4c-1.1,2.3-2.3,4.4-3.5,6.6
					c-0.5,1-1.2,2.1-1.7,3.2c-0.1,0.1-0.1,0.2-0.2,0.2C52.1,82,52.1,82,52,82.1c-0.1,0.1-0.2,0-0.3,0S51.5,82,51.4,82l-2-1.2
					c-1.3-0.8-2.5-1.6-3.7-2.3c-1.6-1-3.3-2.1-4.9-3.1c-3.2-2-6.5-4-9.6-6.1c-0.7-0.5-1.6-0.9-2.5-0.9c-0.6,0-1.3,0.3-1.8,0.7
					c-1.4,1.2-1.8,2.6-1.2,4.4c0.4,1.2,0.9,2.3,1.4,3.4v0.1c0.5,0.8,1,1.7,1.4,2.6c0.8,1.7,1.6,3.4,2.3,5.2c0.4,1.1,0.9,2.3,1.3,3.3
					c2.7,7.2,5.6,14.6,7.5,22.3c0.6,2.6,2.1,4,4.6,4.3c0.7,0.1,1.3,0.2,2,0.2c2.8,0.4,5.5,0.6,8.3,0.7c6.4-0.1,12.8-0.3,19-0.5
					c2.7-0.1,5.5-0.2,8.2-0.3c4.5-0.2,9-0.3,13.5-0.4l5.1-0.2c0.4,0,0.9,0,1.2,0c0.5,0,0.9,0,1.4,0c1.6-0.1,3.2-0.1,4.8-0.2
					c3.9-0.2,8-0.3,12-0.3c1.9,0,3.1-0.6,4.1-2c0.6-1,1.2-2.1,1.5-3.3l0.5-1.7c2.1-6.9,4.3-14.1,5.6-21.4c0.2-0.7,0.2-1.4,0.4-2.1
					C132.8,77.6,133.9,71.6,133.5,65.8z M117.5,105.3c-0.1,0.2-0.2,0.2-0.2,0.3s-0.2,0.2-0.4,0.2c-0.5,0.1-1.2,0.2-1.8,0.2
					c-1.4,0.2-2.8,0.3-4.3,0.4c-2.3,0.1-4.7,0.2-7.1,0.2c-3.1,0.1-6.3,0.2-9.4,0.4c-3.7,0.2-7.4,0.5-11,0.8
					c-2.1,0.2-4.1,0.3-6.2,0.5c-3,0.2-5.5,0.4-8.2,0.5c-6.5,0.2-13,0.4-19.4,0.5l-3.1,0.1h-0.1c-0.3,0-0.5-0.1-0.9-0.1
					c-0.1,0-0.2,0-0.3-0.1c-0.2,0-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.3l-8.2-27.1c-0.1-0.2-0.1-0.3,0-0.5s0.2-0.2,0.2-0.4
					c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.3,0,0.4,0.1l1.1,0.7c0.7,0.5,1.4,0.9,2,1.2c0.9,0.6,1.9,1.2,2.8,1.7c2.3,1.5,4.7,3,6.9,4.5
					c1.5,1,2.7,1.4,3.8,1.2c1-0.2,1.9-1,2.8-2.5l0.8-1.2c1.4-2.4,2.9-4.9,4.1-7.5c4-8.5,8-17.1,12-25.5c1.6-3.3,3.1-6.6,4.6-9.9
					c0.2-0.3,0.2-0.5,0.5-0.9l0.4-0.8c0.1-0.2,0.2-0.2,0.3-0.3s0.2-0.1,0.4-0.1c0.2,0,0.2,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.3
					c0.5,1.3,1.2,2.6,1.7,3.9c1.2,2.7,2.3,5.4,3.3,8.1c2.3,6.2,4.4,12.5,6.6,18.7c1.2,3.5,2.5,7,3.7,10.5c0.6,1.8,1.3,3.6,2.1,5.2
					c0.2,0.6,0.7,1.2,1.2,1.6c0.5,0.5,1.2,0.8,1.8,0.9c1.3,0.2,2.6-0.2,3.8-1.2c1.8-1.6,3.6-3.3,5.4-4.9c1.6-1.4,3.2-2.9,4.7-4.3
					c2-1.8,4-3.6,6.1-5.4l2.7-2.4c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.2,0,0.4,0l0.5,0.2c0.2,0.1,0.3,0.2,0.4,0.3
					c0.1,0.2,0.1,0.3,0.1,0.5C123.8,82.8,121.8,94,117.5,105.3z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
    <ion-label> Panel de embajador</ion-label>
  </ion-item>
  <ion-item routerLink="/wallet">
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 161 118"
      style="enable-background: new 0 0 161 118"
      xml:space="preserve"
    >
      <style type="text/css">
        .st0 {
          clip-path: url(#SVGID_2_);
        }
      </style>
      <g>
        <defs>
          <rect id="SVGID_1_" x="0.1" y="0.4" width="160.1" height="116.8" />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow: visible" />
        </clipPath>
        <g>
          <path
            d="M83.5,116.7c-17.2-0.4-30.7-0.5-44.2-1c-7.7-0.3-15.4-1.1-23.1-2c-2.9-0.4-5.7-1.3-8.4-2.4c-4.1-1.6-6.3-4.9-7-9.2
			c-0.2-1.6-0.4-3.1-0.4-4.7C0.7,86.4,1,75.3,1.3,64.2c0.3-9.5,0.5-19.1,0.8-28.6c0.2-5.4,0.3-10.7,0.7-16.1
			c0.6-7.3,4-12.5,11.3-14.7c2-0.7,4.1-1.2,6.2-1.5c8.2-0.7,16.3-1.6,24.5-1.8C65.9,1.1,87,0.8,108.1,0.7
			c10.7-0.2,21.3,0.5,31.9,1.9c3.3,0.5,6.6,1.2,9.9,2.1c2,0.5,3.8,1.5,5.2,2.9c1.4,1.4,2.4,3.3,2.9,5.2c0.6,2.1,1,4.4,1.2,6.6
			c0.3,11.9,0.7,23.8,0.7,35.7c0.1,13.5-0.6,26.9-3.4,40.2c-0.9,4.4-2.5,8.6-3.9,12.8c-0.9,2.7-3.1,4-5.6,4.9
			c-4.9,1.8-10,2.4-15.2,2.6C114.5,116.3,97.1,117.2,83.5,116.7z M150.2,73.8c-0.5-0.1-1-0.2-1.4-0.2c-8,0.4-15.9,1.1-23.9,1.2
			c-8.1,0.1-16.2-0.2-24.2-0.8c-6.8-0.5-9.9-3.7-11.6-10.3C87.7,58.5,88,53.2,88.8,48c1.1-6.7,3.9-9.4,10.7-10.7
			c8.3-1.6,16.7-2.5,25.1-2.4c7.4,0.1,14.8,0.2,22.2,0.3c1.2,0,2.4-0.1,4-0.2c-0.4-6.1-0.6-11.8-1.1-17.5c-0.2-2.5-1.5-4.1-4.2-4.5
			c-5.2-0.7-10.4-2-15.6-2.2c-13.5-0.6-26.9-0.9-40.4-0.9c-15.6,0-31.2,0.4-46.8,0.7c-4.7,0.1-9.4,0.4-14.1,0.8
			c-3.5,0.3-6.9,0.8-10.3,1.4c-5,0.8-7.6,4.2-8.6,8.8C9,25.1,8.6,28.6,8.6,32.2c-0.2,21.7-0.2,43.4-0.2,65c0,0.8,0,1.6,0.1,2.4
			c0.2,2.5,1.3,4.3,3.8,4.9c1.4,0.4,2.8,0.9,4.2,1.1c9.1,1.5,18.3,1.8,27.5,2c29.8,0.6,59.5,1.5,89.3-0.6c3.8-0.3,7.6-0.7,10.9-2.2
			C148.2,94.8,149.6,84.5,150.2,73.8z M150.6,42.3c-10.4,0.3-20.5,0.3-30.6,0.9c-6.4,0.3-12.7,1.3-19,2.2c-3.2,0.5-4,1.3-4.2,4.3
			c-0.3,4-0.3,8.1,0,12.1c0.2,3.6,1.1,4.2,4.8,4.9c1.3,0.2,2.7,0.4,4,0.5c11.2,1.1,22.4,0.3,33.7-0.1c3.8-0.1,7.5-0.5,11.2-0.8
			C151.5,61.7,151.5,46.2,150.6,42.3L150.6,42.3z"
          />
          <path
            d="M112.1,48.3c4.3-0.9,7,3.1,7,6.7c0,4-2.9,6.9-7,7c-4.3,0.1-8.1-3.2-8-7C104.2,51.1,107.6,48.3,112.1,48.3z"
          />
        </g>
      </g>
    </svg>
    <ion-label translate>Bono monedero</ion-label>
  </ion-item>
  <ion-item href="https://copyfly.es/contacto">
    <ion-icon icon="assets/icon/contact.svg"></ion-icon>
    <ion-label translate>Contacto</ion-label>
  </ion-item>
  <ion-item (click)="doLogout()">
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 141 156"
      style="enable-background: new 0 0 141 156"
      xml:space="preserve"
    >
      <style type="text/css">
        .st0 {
          clip-path: url(#SVGID_2_);
        }
      </style>
      <g>
        <defs>
          <rect id="SVGID_1_" x="0.8" width="140" height="156" />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow: visible" />
        </clipPath>
        <g>
          <path
            d="M40.8,73.2c-4,0.2-8,0.4-12,0.6c-0.2,0-0.5,0-0.7,0c-0.7,0-1.4,0.1-2,0.2c-2.1,0.4-3.2,1.6-3,3.3c0.2,1,1,2.7,2.2,3
			c2.4,0.8,4.8,1.2,7.3,1.3c4.3,0.1,9,0.1,14.6-0.1C62.6,81,78,80.5,93.5,80c8.3-0.3,16.7-0.6,25-0.9c1,0,2,0,3.2,0l0.8,0
			c-0.6,0.6-1.2,1.2-1.8,1.8c-2,2-3.7,3.8-5.4,5.6c-1.6,1.7-3.2,3.5-4.8,5.3c-1.1,1.2-2.2,2.4-3.2,3.6c-1.7,1.9-3.5,3.8-5.3,5.7
			l-2.3,2.5c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0,0.3,0.1,0.4l1.2,2.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1
			c0.1,0,0.2,0,0.2,0c0.2-0.1,0.4-0.1,0.6-0.2c0.5-0.1,1-0.3,1.4-0.6c11.6-8.1,22.8-16.9,33.4-26.3c1-0.9,2-1.9,2.7-3.1
			c1.7-2.5,1.3-5.3-1.1-7.4c-0.6-0.5-1.3-1-2-1.3l-3.8-2.4c-7.7-4.8-15.7-9.7-23.5-14.5c-1.2-0.8-2.5-1.4-3.9-1.7
			c-0.6,0-1.3,0.1-1.9,0.3s-1.1,0.6-1.5,1.1c-0.6,0.9-0.8,2.8-0.1,3.8c1.2,1.7,2.7,3.1,4.4,4.3c2.8,1.9,5.6,3.7,8.4,5.4
			c2.4,1.5,4.8,3.1,7.2,4.7c0.5,0.3,0.9,0.6,1.4,0.8c1.2,0.5,2.2,1.3,3,2.3c-0.8-0.1-1.5-0.1-2.3-0.2c-2.4-0.3-4.8-0.4-7.2-0.5
			l-1.9,0c-15.2,0.1-30.9,0.2-46.4,0.7C59.2,72.2,49.9,72.7,40.8,73.2z"
          />
          <path
            d="M61.7,2c-1.9-0.3-26.6-1.7-41.1-1.8c-2,0.1-4.3,0.3-6.5,0.4C12.5,0.7,10.9,0.9,9.4,1C5.6,1.2,3.2,3.4,2.5,7.2
			c-0.4,2.4-0.6,4.9-0.7,7.3C0.9,34.3,1.1,54.4,1.3,73.8c0,4.6,0.1,9.2,0.1,13.9c0.1,10.3,0.3,21.2,0.7,33.2
			c0.2,5.5,0.5,11,0.8,16.4c0.2,3.4,0.4,6.7,0.5,10.1c0.2,4.2,1.9,6.5,5.6,7.4c2.1,0.5,4.2,0.7,6.4,0.7l1,0c2.6,0.1,5.7,0.2,8.9,0.2
			c13.8,0,31.5-1,39.5-1.5c1-0.1,2-0.5,2.7-1.3c0.7-0.7,1.1-1.7,1.1-2.8c0-1-0.4-2-1.1-2.8c-0.7-0.7-1.7-1.2-2.7-1.3
			c-5.3-0.3-15.2-0.9-21-1.3c-5.5-0.4-11.1-0.6-16.5-0.9c-3.1-0.1-6.2-0.3-9.3-0.4c-1-0.1-2-0.2-3-0.4c-0.3-0.1-0.7-0.1-1-0.2
			c0-0.3-0.1-0.5-0.1-0.8c-0.1-0.7-0.2-1.4-0.3-2.2c-0.2-3.9-0.5-7.9-0.7-11.8c-0.6-9.2-1.2-18.7-1.3-28
			c-0.3-15.8-0.3-31.9-0.2-47.5c0-5,0-10,0-15c0-7.5,0.2-14.9,0.3-21.2c0-1.6,0.2-3.1,0.4-5c0.1-0.7,0.2-1.5,0.2-2.3
			C14.4,9.3,19,9.2,24.8,9c14.8-0.4,35-0.8,38.7-2.6c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.2-1,0.2-1.5
			c0-0.5-0.2-1-0.4-1.4c-0.2-0.3-0.5-0.6-0.8-0.8C62.5,2.1,62.1,2,61.7,2z"
          />
        </g>
      </g>
    </svg>
    <ion-label translate>Cerrar sesión</ion-label>
  </ion-item>
</ion-list>
